export function must0<T>(result: T[]): T {
  return result[0]
}
